import React, { Component }                  from "react"
import { observer }                          from "mobx-react"
import PropTypes                             from "prop-types"
import { Link }                                    from "react-router-dom"
import { Button, Card, Icon, Input, Label, Modal } from "semantic-ui-react"
import Price                                       from "components/Price/Price"
import shop                                  from "shop/shop"
import "components/Product/ProductCard.scss"
import { OrderTableContainer }               from "theme/arnoldsports/pages/ProductPage"
import ButtonLove                            from "components/Button/ButtonLove";

@observer
class ProductCard extends Component {

  state = {
    showOrderTable: false
  }

  toggleModal = () => {
    this.setState( { showOrderTable: !this.state.showOrderTable } )
  }

  render() {
    const { showOrderTable } = this.state
    let { product, categoryId = "" } = this.props
    const inCart = shop.cart.productsById.get( product.map_id ) || product
    const useQuickorder = shop.config.plugin.orderFromTile && shop.session

    return (
      <Card
        className="product ProductCard">
        <div className="wrapper">

          <Link className="product-inner"
                to={`/product/${product.map_id}/?category=${categoryId}`}>
            <div className="image flex items-center justify-center">
              <img src={product.img_src_medium}
                   alt="..."
                   title=""
                   className="img-responsive"/>
            </div>
            <div className="caption ">
              <div className="title" title={product.desc.short_des}>{product.desc.short_des}</div>
              <div className="category black-50 f6" title={product.category.title}>
                {product.extraValue.hersteller} <br/>
              </div>

              {/*<div className="actions">*/}
              {/*  {(this.props.list) ? <ButtonLove list={this.props.list}*/}
              {/*                                   product={product}><Icon*/}
              {/*    name={"heart"}/></ButtonLove> : null} </div>*/}

            </div>
          </Link>
          {this.props.children}

          <div className="badges absolute right-1 top-1 black-50 tr">
            {product.isSale && <div className="pb2"><Label color="red">{product.salePercent}</Label></div>}
            <div className="availability">{product.getNotice( "tiny", product.extraValue.varbestand )}</div>
          </div>

          {product.price !== undefined ? <div>
            <div className="absolute right-1 bottom-1">
              <ButtonLove list={shop.orderlist.default}
                          className="dib mr3"
                          elementInActive={<span><Icon name={"heart"}/></span>}
                          elementActive={<span><Icon name={"heart"}/></span>}
                          product={product}/>

              {product.mainart && <Button onClick={this.toggleModal} basic icon="cart"/>}
              {!product.mainart && <Button basic icon="eye" as={Link} to={`/product/${product.map_id}/?category=${categoryId}`}/>}

              {/*<Button primary className="" basic icon={"cart"} onClick={() => {*/}
              {/*	if ( product.count ) {*/}
              {/*		product.count += 1*/}
              {/*	} else {*/}
              {/*		product.count = 1*/}
              {/*	}*/}
              {/*	shop.cart.add( product )*/}
              {/*	shop.toast( `${product.count}x ${product.title} ${translate("im Warenkorb")}`, "info", false, "bottom" )*/}
              {/*}}/>*/}
            </div>
            {product.isSale &&
            <div className="price absolute bottom-1 left-1 color" title={translate( "Stückpreis" )}>
              {/*<span className="unit_multi black-70 f6 pb2 fw2">Stückpreis</span><br/>*/}
              <span className="f5 black-60 strike"><Price currency={shop.session.value.currency ? shop.session.value.currency : '€'}>{product.pinfos.brutto}</Price></span> <br/>
              <span className="f5 red b"><Price currency={shop.session.value.currency ? shop.session.value.currency : '€'}>{product.price}</Price></span>
            </div>}
            {!product.isSale &&
            <div className="price absolute bottom-1 left-1 color">
              <span className="unit_multi black-70 f6 pb2 fw2">{translate( "ab" )} </span><br/>
              <span className="f5  b"><Price currency={shop.session.value.currency ? shop.session.value.currency : '€'}>{product.price}</Price></span>
            </div>}
          </div> : <div className="absolute right-1 bottom-1 left-1">
            <Link to={`/login/?referrer=/product/${product.map_id}`}> <Button fluid basic>{translate( "Preise anzeigen" )} </Button></Link>
          </div>
          }
        </div>

        {useQuickorder &&
        <div className="QuickorderTab flex flex-auto pt3 mb3" style={{ justifyContent: "space-between" }}>
          <div className="quickorder-count">
            {inCart.count * inCart.unit_multi} <br/>
            {translate( "piece" )}
          </div>

          <div className="quickorder-input">
            <Input value={inCart.count}/>
          </div>

          <div className="quickorder-actions">
            <Button floated="right" icon="plus" onClick={() => {
              if ( inCart.count ) {
                inCart.count += 1
              } else {
                inCart.count = 1
              }
              shop.cart.add( inCart )
            }
            }/><Button floated="right" icon="minus" onClick={() => {
            if ( inCart.count > 0 ) {
              inCart.count -= 1
            } else {
              inCart.count = 0
            }
            shop.cart.add( inCart )
          }
          }/>
          </div>

        </div>}


        {showOrderTable && <Modal open size={"fullscreen"}>
          <Modal.Header>
            {product.desc.short_des.split( "," )[ 0 ]}
            <div className="absolute right-1 top-1"><Button basic circular icon="times" onClick={this.toggleModal}/></div>
          </Modal.Header>
          <Modal.Content className={"relative"}>
            <OrderTableContainer product={product} key={product.map_id}/>
            <div className="absolute bottom-1 left-1">
              <Button basic onClick={this.toggleModal}>{translate( "Zurück" )}</Button>
            </div>
          </Modal.Content>
        </Modal>}

      </Card>
    )
  }
}

ProductCard.defaultProps = {
  quickorder: false
}

ProductCard.propTypes = {
  quickorder: PropTypes.any,
  list      : PropTypes.object,
  product   : PropTypes.object,
  xs        : PropTypes.string,
  sm        : PropTypes.string,
  md        : PropTypes.string,
  lg        : PropTypes.string,
}

export default ProductCard



// WEBPACK FOOTER //
// ./src/theme/arnoldsports/components/Product/ProductCard.js